<template>
  <div class="wrap" v-loading="loading">
    <div class="detail-t">
      <div class="imgbox">
        <!-- <el-image :src="`/backstage/sysFile/getFileStream?fileId=${detail.courseCoverFileId}`"></el-image> -->
        <!-- <el-image :src="detail.courseCoverFileUrl"></el-image> -->
        <img :src="detail.courseCoverFileUrl" alt="" />
      </div>
      <div class="detail-t-r">
        <div class="big-title">{{ detail.courseName }}</div>
        <div class="small-title">课程简介</div>
        <div
          class="summary custom_scroll"
          v-html="detail.courseIntroduction"
          v-if="detail.courseIntroduction"
        ></div>
        <div class="nodata" v-else>暂无简介</div>
        <div class="btnbox">
          <el-button
            v-if="!detail.hasSignUp"
            type="primary"
            size="small"
            @click="handleApply()"
            >报名学习</el-button
          >
          <el-button
            v-if="detail.hasSignUp"
            type="primary"
            size="small"
            @click="handleStudy()"
            >去学习</el-button
          >
        </div>
      </div>
    </div>
    <div class="detail-main" ref="detailMain">
      <el-tabs
        ref="tabs"
        tab-position="left"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="课程设计" name="first" ref="firstTab">
          <div class="tab-content design" ref="first">
            <div>
              <div class="title">课程简介</div>
              <div
                class="txt"
                v-html="detail.courseIntroduction"
                v-if="detail.courseIntroduction"
              ></div>
              <div class="nodata" style="height: 100px" v-else>暂无简介</div>
            </div>
            <div v-for="(item, index) in detail.designModuleList" :key="index">
              <div class="title module-title">{{ item.title }}</div>
              <div class="txt" v-html="item.content"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="学习资源" name="second" ref="secondTab" lazy>
          <div class="tab-content" ref="second">
            <div class="nodata">暂无数据</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课程公告" name="third" ref="thirdTab" lazy>
          <div class="tab-content notice" ref="third">
            <course-notice :activeName="activeName"></course-notice>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CourseNotice from './detail/CourseNotice.vue'
export default {
  components: { CourseNotice },
  data() {
    return {
      loading: false,
      activeName: 'first',
      id: this.$route.query.id,
      detail: {}
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      this.$api.courseManage.getCourseDetail({ courseId: this.id }).then(res => {
        this.detail = res.data
        this.setMainHeight()
      }).finally(() => {
        this.loading = false
      })
    },
    handleClick(tab, event) {
      this.setMainHeight()
      this.resetTabActivePosition(this.$refs.tabs.$el)
    },
    //报名学习
    handleApply() {
      this.$confirm(`是否确认报名学习该课程？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$api.myCourse.signUpCourse({ courseId: this.id })
          .then((res) => {
            if (res) {
              this.getDetail()
              this.$confirm('报名成功！', '提示', {
                confirmButtonText: '前往学习',
                cancelButtonText: '返回上一级',
                distinguishCancelAndClose: true,
                type: 'success',
              }).then(() => {
                //判断是虚仿课还是普通课，进入不同的路由
                if (this.detail.courseCategory == 2) {
                  this.$router.push({ path: '/myCourse/videoDetail', query: { id: this.id } })
                } else {
                  this.$router.push({ path: '/myCourse/virtualDetail', query: { id: this.id } })
                }
              }).catch((action) => {
                if (action == "cancel") {
                  this.$router.push({ path: '/portal/search' })
                }
              });
            }
          })
          .catch((error) => {
            throw error
          }).finally(() => {
            this.loading = false
          })
      })
    },
    handleStudy() {
      //判断是虚仿课还是普通课，进入不同的路由
      if (this.detail.courseCategory == 2) {
        this.$router.push({ path: '/myCourse/videoDetail', query: { id: this.id } })
      } else {
        this.$router.push({ path: '/myCourse/virtualDetail', query: { id: this.id } })
      }
    },
    //设置主内容区域的高度
    setMainHeight() {
      this.$nextTick(() => {
        let height = this.$refs[this.activeName].offsetHeight;
        // let height = this.$refs[`${this.activeName}Tab`].$el.offsetHeight;
        // this.$refs.detailMain.style.height = height + 'px';
      })
    },
    resetTabActivePosition($el) {
      this.$nextTick(() => {
        const activeEl = $el.querySelector('.el-tabs__item.is-active');
        const lineEl = $el.querySelector('.el-tabs__active-bar');
        const style = getComputedStyle(activeEl);
        const pt = style.paddingTop.match(/\d+/)[0] * 1;
        const pb = style.paddingBottom.match(/\d+/)[0] * 1;
        const h = style.height.match(/\d+/)[0] * 1;
        lineEl.style.transform = 'translateY(' + (activeEl.offsetTop + pt) + 'px)';
        lineEl.style.height = (h - pt - pb) + 'px';
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 1200px;
  margin: 60px auto;
  .detail-t {
    display: flex;
    background-color: #fff;
    padding: 24px;
    overflow: hidden;
    .imgbox {
      width: 574px;
      height: 360px;
      .el-image,
      img {
        width: 100%;
        height: 100%;
      }
    }
    .detail-t-r {
      flex: 1;
      height: 360px;
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .big-title {
        line-height: 32px;
        font-size: 24px;
        margin-top: 16px;
        font-weight: 700;
      }
      .small-title {
        font-size: 20px;
        line-height: 24px;
        margin-top: 16px;
      }
      .summary {
        margin-top: 16px;
        line-height: 24px;
        flex: 1;
        overflow-y: auto;
      }
      .btnbox {
        margin-top: 16px;
        text-align: right;
      }
    }
  }
  .detail-main {
    margin-top: 40px;
    background-color: #fff;
    min-height: 500px;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs {
      flex: 1;
      display: flex;
      align-items: stretch;
      .el-tabs__header {
        height: 100%;
        .el-tabs__nav-wrap::after {
          background-color: #ebedf2;
          width: 1px;
        }
        .el-tabs__item {
          width: 176px;
          text-align: center;
          height: 56px;
          line-height: 56px;
          margin-top: 28px;
          font-size: 16px;
          font-weight: 700;
          color: #636b79;
          &.is-active,
          &:hover {
            color: $--color-primary;
          }
        }
      }
      .el-tabs__content {
        flex: 1;
        min-height: 100%;
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    .tab-content {
      height: 100%;
      padding: 24px 0;
      &.design {
        padding: 24px 80px;
        .title {
          font-weight: 700;
          font-size: 16px;
        }
        .module-title {
          margin-top: 16px;
        }
        .txt {
          margin-top: 16px;
          line-height: 32px;
          /deep/ table td,
          /deep/ table th {
            border: 1px solid #ccc;
            text-align: center;
            padding: 6px;
          }
          /deep/ table th {
            border-bottom: 2px solid #ccc;
          }
        }
      }
      &.notice {
        min-height: 800px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/portal/search/detail.vue